module.exports = __webpack_public_path__ + "static/media/Guyana.33ecb243.png";